import { SearchableSelect } from '@/components/ui/searchable-select'
import { useAssignableUsers } from '@/hooks/useAssignableUsers'
import { useAuth } from '@/providers/AuthProvider'

const EVERYONE = '__all__'

/**
 * Narrow a task tab to one person's tasks (z8nrz7fgzw), with the tenant's
 * assignable users — the viewer first, as "(me)".
 */
export function ResourceFilter({ value, onChange }: { value: string | null; onChange: (id: string | null) => void }) {
  const { users } = useAssignableUsers()
  const { user } = useAuth()
  const meId = user?.userId ?? null
  const ordered = meId ? [...users.filter((u) => u.id === meId), ...users.filter((u) => u.id !== meId)] : users
  const options = [
    { value: EVERYONE, label: 'All resources' },
    ...ordered.map((u) => ({ value: u.id, label: u.id === meId ? `${u.name} (me)` : u.name })),
  ]
  return (
    <SearchableSelect
      value={value ?? EVERYONE}
      onChange={(v) => onChange(v === EVERYONE ? null : v)}
      options={options}
      className='w-56'
      buttonClassName='h-9 text-xs'
      triggerTitle='Resource'
    />
  )
}
